import { render, staticRenderFns } from "./WizardIterableText.vue?vue&type=template&id=2ab22948"
import script from "./WizardIterableText.vue?vue&type=script&lang=ts"
export * from "./WizardIterableText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports